"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const RegisterIcon = createIcon({
  displayName: "RegisterIcon",
  viewBox: "0 0 45 36",
  path: (
    <>
      <path
        d="M0,35.12v-6.15c0-1.21.32-2.34.96-3.4.64-1.06,1.52-1.87,2.64-2.41,1.91-.95,4.07-1.76,6.47-2.41,2.4-.66,5.04-.99,7.93-.99,1.12,0,2.22.05,3.29.16,1.07.11,2.11.27,3.12.49l-3.94,3.84c-.41-.07-.82-.11-1.21-.11h-1.27c-2.66,0-5.05.31-7.17.93-2.12.62-3.85,1.3-5.2,2.03-.34.18-.61.44-.82.77-.21.33-.31.7-.31,1.1v1.76h14.06l4.5,4.39H0ZM30.49,36l-7.76-7.57,3.15-3.07,4.61,4.5,11.36-11.09,3.15,3.07-14.51,14.16ZM18,17.56c-2.48,0-4.59-.86-6.36-2.58-1.76-1.72-2.64-3.79-2.64-6.2s.88-4.48,2.64-6.2c1.76-1.72,3.88-2.58,6.36-2.58s4.59.86,6.36,2.58c1.76,1.72,2.64,3.79,2.64,6.2s-.88,4.48-2.64,6.2c-1.76,1.72-3.88,2.58-6.36,2.58ZM18,13.17c1.24,0,2.3-.43,3.18-1.29.88-.86,1.32-1.89,1.32-3.1s-.44-2.24-1.32-3.1c-.88-.86-1.94-1.29-3.18-1.29s-2.3.43-3.18,1.29c-.88.86-1.32,1.89-1.32,3.1s.44,2.24,1.32,3.1c.88.86,1.94,1.29,3.18,1.29Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default RegisterIcon;
